import { GetServerSideProps } from 'next'

import { AppLayout } from '@components/layouts/AppLayout'
import { SearchByEnum } from '@interfaces/SearchByEnum'
import { OrderedEnum } from '@interfaces/OrderedEnum'
import { SearchPage } from '@features/search/pages/SearchPage'
import { SearchProps } from '@features/search/pages/SearchPage/interface'
import { BASE_URL } from '@configs/config'
import { OgShare } from '@components/OgShare'
import { SearchLayout } from '@features/search/components/SearchLayout'
import { maintenanceHandler } from '@lib/maintenanceHandler'

function StorySearch({ secondaryType, url, ...props }: SearchProps) {
  const newProps = {
    ...props,
    secondaryType: secondaryType || undefined,
  }

  return (
    <AppLayout>
      <OgShare url={url} />
      <SearchLayout>
        <SearchPage {...newProps} />
      </SearchLayout>
    </AppLayout>
  )
}

export const getServerSideProps: GetServerSideProps = async ({
  query,
  req,
}) => {
  return maintenanceHandler({
    text: query.text || '',
    secondaryType: query.secondaryType || null,
    orderBy: query.orderBy || OrderedEnum.NEW_OLD,
    tab: query.tab || SearchByEnum.ALL,
    advanceSearch: query.advanceSearch === 'true',
    url: `${BASE_URL}${req.url}`,
  })
}

export default StorySearch
